import React from "react"
import { v4 as uuidv4 } from "uuid"
import { getMediaUrl } from "../../utils/media"

function LandingImageTextSection({
  landingImageTextSectionTitle,
  landingImageTextSectionItems,
}) {
  return (
    <section className="landing-image-text section-spacing-lg bg-white">
      <div className="content-block">
        {landingImageTextSectionTitle && (
          <h3
            className="landing-image-text__title lp-heading-lg"
            dangerouslySetInnerHTML={{ __html: landingImageTextSectionTitle }}
          ></h3>
        )}

        {landingImageTextSectionItems &&
          landingImageTextSectionItems.length > 0 && (
            <div className="landing_image_text_section_items_wrapper">
              {landingImageTextSectionItems.map((group, index) => {
                const img = group.landingImageTextSectionItemImage
                return (
                  <div
                    className="landing_image_text_section_item"
                    key={uuidv4()}
                    id={
                      group.landingImageTextSectionItemId
                        ? group.landingImageTextSectionItemId
                        : "landing-image-text__" + String(index)
                    }
                  >
                    <div className="landing_image_text_section_item__wrapper">
                      {group.landingImageTextSectionItemTitle && (
                        <h4 className="landing-image-text-item__title lp-heading-sm">
                          {group.landingImageTextSectionItemTitle}
                        </h4>
                      )}

                      {group.landingImageTextSectionItemText && (
                        <div
                          className="landing-image-text-item__text lp-body-lg"
                          dangerouslySetInnerHTML={{
                            __html: group.landingImageTextSectionItemText,
                          }}
                        />
                      )}

                      {group.landingImageTextSectionItemButton && (
                        <span className="landing-image-text-item-button__wrapper">
                          <a
                            href={group.landingImageTextSectionItemButton.url}
                            className="landing-image-text-item__button lp-heading-sm"
                          >
                            {group.landingImageTextSectionItemButton.title}
                          </a>
                        </span>
                      )}
                    </div>

                    {img && getMediaUrl(img) && (
                      <figure className="landing-image-text-item__image">
                        <span className="landing-image-text-item-image__wrapper">
                          <img
                            src={getMediaUrl(img)}
                            alt={img.altText || ""}
                            title={img.title || ""}
                            width="100%"
                            height="100%"
                          />
                        </span>
                        {group.landingImageTextSectionItemImageCaption && (
                          <figcaption className="landing-image-text__figcaption">
                            {group.landingImageTextSectionItemImageCaption}
                          </figcaption>
                        )}
                      </figure>
                    )}
                  </div>
                )
              })}
            </div>
          )}
      </div>
    </section>
  )
}

export default LandingImageTextSection
